import React from 'react';
import { Link } from 'react-router-dom';

import localStorage from '../../Common/LocalStorage';
import LocalizedStrings from 'react-localization';
import { translations } from '../../Common/Translations';
import { StaticRoutePaths } from '../../Common/ClientRoutes';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang') !== undefined ? localStorage.getFromStorage('lang') : 'en');

const CompanyDetails = props => {
    return (
        <div>
            {props.hasCompany ? (
                <div>
                    <div className="row">
                        <div className="col-12 color-dark-gray">{strings.company_name}</div>
                        <div className="col-12 color-light-blue mb-1 qf-big-text">{props.companyName}</div>
                    </div>

                    <div className="row">
                        <div className="col-12 color-dark-gray">{strings.pharmacy_count}</div>
                        <div className="col-12 color-light-blue mb-1 qf-big-text">{props.pharmacyCount}</div>
                    </div>

                    <div className="row">
                        <div className="col-12 color-dark-gray">{strings.address}</div>
                        <div className="col-12 color-light-blue mb-1 qf-big-text">{props.address}</div>
                    </div>
                    <div className="row">
                        <div className="col-12 color-dark-gray">{strings.phone}</div>
                        <div className="col-12 color-light-blue mb-1 qf-big-text">{props.phone}</div>
                    </div>
                    <div className="row">
                        <div className="col-12 color-dark-gray">{strings.Email}</div>
                        <div className="col-12 color-light-blue mb-1 qf-big-text">{props.email ? props.email : strings.no_email_set}</div>
                    </div>
                    <div className="row">
                        <div className="col-12 color-dark-gray">{strings.owner}</div>
                        <div className="col-12 color-light-blue mb-1 qf-big-text">{props.owner ? props.owner : strings.no_owner_set}</div>
                    </div>
                    <div className="row">
                        <div className="col-2 qf-mb-30" style={{ marginTop: '30px' }}>
                            <Link className="qf-blue-btn" to={StaticRoutePaths.INFO_EDIT_COMPANY + '/' + props.companyId}>
                                {strings.edit_company}
                            </Link>
                        </div>
                    </div>
                </div>
            ) : (
                <div>
                    <div className="row">
                        <div className="col-12 color-dark-gray">You don't have Company.</div>
                    </div>
                    <div className="row">
                        <div className="col-2 qf-mb-30" style={{ marginTop: '30px' }}>
                            <Link className="qf-blue-btn w-100" to={StaticRoutePaths.INFO_NEW_COMPANY}>
                                {strings.add_company}
                            </Link>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CompanyDetails;



// WEBPACK FOOTER //
// ./src/customModules/Common/company/Company-details.js